import axios from "axios";
import { Message } from "element-ui";
import api from "@/config/api";
import { isTokenValid } from "@/utils/auth";

// 是否已经提示过登录过期
let hasTokenExpiredTip = false;

// 创建 axios 实例
const service = axios.create({
    baseURL: api.rootUrl,
    timeout: 10000,
});

// 不需要 token 的接口白名单
const noAuthList = ["/api/pub/login/byWeb"];

// 请求拦截
service.interceptors.request.use(
    (config) => {
        const isNoAuth = noAuthList.some((url) => config.url.includes(url));

        if (!isNoAuth) {
            // if (!isTokenValid()) {
            //     if (!hasTokenExpiredTip) {
            //         hasTokenExpiredTip = true; // 避免重复提示
            //         Message.error("登录已过期，请重新登录");
            //     }
            //     localStorage.clear();
            //     window.location.hash = "#/login";
            //
            //     // ❗ 关键：阻止请求继续发送
            //     return Promise.reject({ message: "token expired" });
            // }
            //
            const token = localStorage.getItem("molv_token");
            if (token) {
                config.headers["molv-token"] = token;
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截
service.interceptors.response.use(
    (response) => {
        const res = response.data;

        if (res.errCode !== 0) {
            // 如果是 token 过期，这里不重复提示
            if (res.errMsg?.includes("token") || res.errMsg?.includes("过期")) {
                return Promise.reject(res);
            }

            Message.error(res.errMsg || "请求失败");
            return Promise.reject(res);
        }
        return res;
    },
    (error) => {
        // token 过期的错误，这里也不处理（因为前面已经提示过了）
        if (error?.message === "token expired") {
            return Promise.reject(error);
        }

        // 正常错误提示
        Message.error(
            error?.response?.data?.errMsg ||
            error?.response?.data?.message ||
            error.message ||
            "请求失败"
        );
        return Promise.reject(error);
    }
);

export default service;
